import { Box } from '@apia/theme';
import React, {
  ChangeEvent,
  KeyboardEvent,
  useCallback,
  useEffect,
} from 'react';
import useStateRef from 'react-usestateref';
import { getCurrentListId } from '../apia/common/lists/hooks/useCurrentListId';
import { useAppSelector } from '../../hooks/hooks';
import ApiaDateFilter from './ApiaDateFilter';
import { IApiaFilter } from './ApiaFilter';
import Input from './Input';
import store from '../../store';
import { listActions } from '../../store/listSlice';
import { TApiaFilter } from '../../types';

export const TimeInput = ({
  onChange,
  value: outerValue,
  // filter,
  className,
  // shouldShowRedBorderOnRequired,
}: {
  onChange?: (value: string) => unknown;
  value?: string;
  filter: TApiaFilter;
  className?: string;
  shouldShowRedBorderOnRequired?: boolean;
}) => {
  const [value, setValue, valueRef] = useStateRef(outerValue);

  useEffect(() => {
    setValue(outerValue);
  }, [outerValue, setValue]);

  return (
    <Input
      value={value}
      className={`${className}`}
      type="time"
      onChange={useCallback(
        (ev: ChangeEvent<HTMLInputElement>) => {
          setValue(ev.target.value);
        },
        [setValue],
      )}
      onBlur={useCallback(() => {
        onChange?.(valueRef.current as string);
      }, [onChange, valueRef])}
      onKeyDown={useCallback(
        (ev: KeyboardEvent) => {
          if (ev.code === 'Enter') {
            onChange?.(valueRef.current as string);
          }
        },
        [onChange, valueRef],
      )}
    />
  );
};

const DateHour = React.forwardRef<HTMLInputElement, IApiaFilter>(
  (
    {
      filter,
      onChange,
      onBlur,
      onPressEnter,
      shouldShowRedBorderOnRequired,
      className,
    },
    ref,
  ) => {
    const fieldId = getCurrentListId();
    const reduxFilters =
      useAppSelector((global) => {
        return global.listSlice.lists[fieldId]?.filters?.filter((current) => {
          return (
            current.type === 'dateHour' &&
            filter.id === current.groupedInputFirstId &&
            current.id !== current.groupedInputFirstId
          );
        });
      }) ?? [];
    return (
      <>
        <Box className="dateHour__container">
          <ApiaDateFilter
            filter={filter}
            onChange={onChange}
            onBlur={onBlur}
            onPressEnter={onPressEnter}
            className={`${className}`}
            ref={ref}
          />
        </Box>
        <Box className="hourInput__container">
          <TimeInput
            filter={filter}
            className={`${className} hourInput`}
            shouldShowRedBorderOnRequired={shouldShowRedBorderOnRequired}
            value={reduxFilters[0].currentValue as string}
            onChange={(e: string) => {
              void store.dispatch(
                listActions.setFilters({
                  listId: fieldId,
                  filters: [
                    { ...filter },
                    {
                      ...reduxFilters[0],
                      currentValue: e,
                    },
                  ],
                  onlyRedux: true,
                }),
              );
            }}
          />
        </Box>
      </>
    );
  },
);

export default DateHour;
